import le from "../../../@babel/runtime/helpers/esm/defineProperty.mjs";
import T from "../../../@babel/runtime/helpers/esm/slicedToArray.mjs";
import * as n from "react";
import { useState as $ } from "react";
import ie from "../../../classnames/index.mjs";
import me from "../../../rc-util/es/pickAttrs.mjs";
import se from "../../../rc-overflow/es/Overflow.mjs";
import ue from "../TransBtn.mjs";
import pe from "./Input.mjs";
import fe from "../hooks/useLayoutEffect.mjs";
import { getTitle as de } from "../utils/commonUtil.mjs";
function ve(e) {
  var i;
  return (i = e.key) !== null && i !== void 0 ? i : e.value;
}
var F = function(e) {
  e.preventDefault(), e.stopPropagation();
}, Ne = function(e) {
  var i = e.id, g = e.prefixCls, h = e.values, s = e.open, P = e.searchValue, C = e.autoClearSearchValue, K = e.inputRef, M = e.placeholder, b = e.disabled, u = e.mode, k = e.showSearch, V = e.autoFocus, z = e.autoComplete, A = e.activeDescendantId, B = e.tabIndex, L = e.removeIcon, O = e.maxTagCount, d = e.maxTagTextLength, E = e.maxTagPlaceholder, v = E === void 0 ? function(t) {
    return "+ ".concat(t.length, " ...");
  } : E, I = e.tagRender, W = e.onToggleOpen, j = e.onRemove, q = e.onInputChange, G = e.onInputPaste, H = e.onInputKeyDown, J = e.onInputMouseDown, Q = e.onInputCompositionStart, U = e.onInputCompositionEnd, x = n.useRef(null), X = $(0), y = T(X, 2), Y = y[0], Z = y[1], _ = $(!1), w = T(_, 2), ee = w[0], D = w[1], a = "".concat(g, "-selection"), p = s || u === "multiple" && C === !1 || u === "tags" ? P : "", te = u === "tags" || u === "multiple" && C === !1 || k && (s || ee);
  fe(function() {
    Z(x.current.scrollWidth);
  }, [p]);
  function N(t, o, r, m, c) {
    return /* @__PURE__ */ n.createElement("span", {
      className: ie("".concat(a, "-item"), le({}, "".concat(a, "-item-disabled"), r)),
      title: de(t)
    }, /* @__PURE__ */ n.createElement("span", {
      className: "".concat(a, "-item-content")
    }, o), m && /* @__PURE__ */ n.createElement(ue, {
      className: "".concat(a, "-item-remove"),
      onMouseDown: F,
      onClick: c,
      customizeIcon: L
    }, "×"));
  }
  function ne(t, o, r, m, c) {
    var l = function(f) {
      F(f), W(!s);
    };
    return /* @__PURE__ */ n.createElement("span", {
      onMouseDown: l
    }, I({
      label: o,
      value: t,
      disabled: r,
      closable: m,
      onClose: c
    }));
  }
  function oe(t) {
    var o = t.disabled, r = t.label, m = t.value, c = !b && !o, l = r;
    if (typeof d == "number" && (typeof r == "string" || typeof r == "number")) {
      var f = String(l);
      f.length > d && (l = "".concat(f.slice(0, d), "..."));
    }
    var S = function(R) {
      R && R.stopPropagation(), j(t);
    };
    return typeof I == "function" ? ne(m, l, o, c, S) : N(t, l, o, c, S);
  }
  function ae(t) {
    var o = typeof v == "function" ? v(t) : v;
    return N({
      title: o
    }, o, !1);
  }
  var re = /* @__PURE__ */ n.createElement("div", {
    className: "".concat(a, "-search"),
    style: {
      width: Y
    },
    onFocus: function() {
      D(!0);
    },
    onBlur: function() {
      D(!1);
    }
  }, /* @__PURE__ */ n.createElement(pe, {
    ref: K,
    open: s,
    prefixCls: g,
    id: i,
    inputElement: null,
    disabled: b,
    autoFocus: V,
    autoComplete: z,
    editable: te,
    activeDescendantId: A,
    value: p,
    onKeyDown: H,
    onMouseDown: J,
    onChange: q,
    onPaste: G,
    onCompositionStart: Q,
    onCompositionEnd: U,
    tabIndex: B,
    attrs: me(e, !0)
  }), /* @__PURE__ */ n.createElement("span", {
    ref: x,
    className: "".concat(a, "-search-mirror"),
    "aria-hidden": !0
  }, p, " ")), ce = /* @__PURE__ */ n.createElement(se, {
    prefixCls: "".concat(a, "-overflow"),
    data: h,
    renderItem: oe,
    renderRest: ae,
    suffix: re,
    itemKey: ve,
    maxCount: O
  });
  return /* @__PURE__ */ n.createElement(n.Fragment, null, ce, !h.length && !p && /* @__PURE__ */ n.createElement("span", {
    className: "".concat(a, "-placeholder")
  }, M));
};
export {
  Ne as default
};
//# sourceMappingURL=MultipleSelector.mjs.map
